import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Colors } from 'context';
import { ISkillDemand } from 'core/hooks/Growth/transform/transformSkillMap';
import fontService, { TextType } from 'services/FontService';

/**
 * Полоса востребованности навыка (ТЗ 0039 шаг 5, вынесена в 0040-доводке).
 *
 * 🔴 Общий компонент, а не копия. Число живых вакансий показывают уже два
 * экрана — «Мой рост» и занятие, — и посчитанное или покрашенное порознь оно
 * разойдётся у них на глазах у одного и того же студента. Полосу задаёт
 * сервер (`band`), здесь она только рисуется.
 *
 * ⚠️ Формулировка «в нашей ленте» обязательна и живёт в ключах перевода:
 * метрика меряет НАШУ доску вакансий, а не рынок труда. Без оговорки это
 * выдача выборки за рынок.
 */
export const SkillDemandLine = memo(({ demand }: { demand: ISkillDemand | null }) => {
  const { t } = useTranslation();
  if (!demand) return null;

  return (
    <Demand>
      <Bars>
        {[1, 2, 3].map((step) => (
          <Bar key={step} filled={demand.band >= step} />
        ))}
      </Bars>
      <DemandText>
        {demand.liveVacancies
          ? t('growth.map.demandCount', { n: demand.liveVacancies })
          : t('growth.map.demandNone')}
      </DemandText>
    </Demand>
  );
});

SkillDemandLine.displayName = 'SkillDemandLine';

const Demand = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Bars = styled.div`
  display: flex;
  gap: 3px;
`;

const Bar = styled.span<{ filled: boolean }>`
  width: 14px;
  height: 5px;
  border-radius: 3px;
  background: ${({ filled }) => (filled ? Colors.main : Colors.gray)};
`;

const DemandText = styled.span`
  color: ${Colors.gray_dark};
  ${fontService.text({ type: TextType.extraSmall })}
`;
